module.exports = __webpack_public_path__ + "img/Logo.7d6477941.8105d5b5.svg";